import config from '@/helpers/config';

export function getImgUrl(key) {
  const baseUrl = config && config.baseUrl ? config.baseUrl : "";
  return `${baseUrl}/v2/public_file/${key}`;
}